import React from "react";

const OpenModalIcon = ({ click, icon }) => (
  <a onClick={click} href="# " data-toggle="modal" data-target="#modal">
    <i id="icon" className={icon} />
  </a>
);

export default OpenModalIcon;
